import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

export default function Auth() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async ({ username, password }) => {
    try {
      const res = await axiosInstance.post("/admin/login", {
        username,
        password,
      });

      if (res.status === 200) {
        // Save to localStorage
        const { token } = res.data; // extract actual token from response
        localStorage.setItem("ummes_token", token);
        navigate("/app/cp-4f3a2b-admin-portal-x8y7z");
      }
    } catch (err) {
      console.log(err.message);
      alert("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md transform transition-all duration-300 hover:scale-105">
        <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
          Admin Login
        </h2>

        <form
          onSubmit={(e) => {
            e.preventDefault(); // Prevent page reload
            handleLogin({ username, password }); // Trigger login
          }}
        >
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition duration-200">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
